import React from 'react';

import { useRecoilValue } from 'recoil';

import { io } from 'lib/helpers/utility';

import ProceduresProducts from 'components/Patient/sell/ProceduresProducts';
import SellPackagePatient from 'components/Patient/sell/SellPackagePatient';
import InvoiceReadOnly from 'components/Payments/components/InvoiceReadOnly';
import { currentPractice } from 'components/practice/practiceState';
import Input from 'components/shared/Input/Input';
import Allowed from 'components/shared/Permissions/Allowed';

import PrintView from './PrintView';

const QuoteContent = ({
  ref,
  mode,
  invoice,
  setInvoice = () => {},
  formik,
  services = [],
  products = [],
  packages = []
}) => {
  const practice = useRecoilValue(currentPractice);
  return (
    <div className="flex  flex-col !gap-5 bg-white" ref={ref}>
      {mode.readonly && io(invoice) ? (
        <div>
          {mode.readonly && !mode.created && (
            <InvoiceReadOnly invoices={[invoice]} from="quote" setInvoice={setInvoice} />
          )}

          {mode.created && (
            <PrintView
              practice={practice}
              createdAt={invoice?.created_at}
              patient={formik?.values?.patient}
              content={<InvoiceReadOnly invoices={[invoice]} />}
            />
          )}
        </div>
      ) : (
        <>
          <Input
            data-qa="enter-quote-name"
            required
            id="name"
            name="name"
            type="text"
            label="Quote name"
            value={formik?.values?.name}
            placeholder="Enter quote name"
            onChange={formik && formik?.handleChange}
            error={formik?.touched?.name && formik?.errors?.name}
          />

          <SellPackagePatient formik={formik} />
          <Allowed
            requiredPermissions={['products.read', 'packages.read', 'services.read']}
            isAny={true}>
            {services && (
              <ProceduresProducts
                isQuote={true}
                formik={formik}
                products={products}
                services={services}
                packages={packages}
                key={products?.length + packages?.length}
              />
            )}
          </Allowed>
        </>
      )}
    </div>
  );
};

export default QuoteContent;
